export default __webpack_public_path__ + "static/appright-8c8f5e7226c84b42ccc2ea645ea6e415.svg";